<!--
 * @Description:日期选择框，重写日期后缀
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-03-06 14:27:43
 * @LastEditors: mdb
-->
<template>
  <CosInputView v-if="view" v-bind="$attrs" :value="viewVal" />
  <a-range-picker
    v-else
    style="width: 100%"
    v-model:value="time"
    v-bind="$attrs"
    :valueFormat="formFormat"
    :showTime="showTime"
    @change="change"
  />
</template>
<script lang="ts">
import { ref, watch, computed } from 'vue'
import cosRangePickerProps from '../cosRangePicker'
import CosInputView from '@/components/Antd/CosView/input.vue'
import dayjs from 'dayjs'
import { toBeijingTime } from '@/utils/timeFormat'
export default { name: 'CosRangePicker' }
</script>
<script setup lang="ts">
const props = defineProps(cosRangePickerProps())
const emit = defineEmits(['update:startTime', 'update:endTime', 'change'])
const time = ref<any[]>([])
const resultTime = ref<any[]>([])
watch(
  () => props.startTime,
  (v, prev) => {
    if (v !== resultTime.value[0]) {
      if (v && props.endTime) {
        time.value = [v, props.endTime]
      } else {
        time.value = []
      }
    }
  },
  { immediate: true }
)
const viewVal = computed(() => {
  const valueFormat = props.valueFormat ? props.valueFormat : props.showTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD'
  let result = ''
  if (props.startTime) {
    result += dayjs(props.startTime).format(valueFormat)
  }
  if (props.endTime) {
    result += ' - ' + dayjs(props.endTime).format(valueFormat)
  }
  if (!result) {
    result = '--'
  }
  return result
})
const formFormat = computed(() => {
  return props.valueFormat ? props.valueFormat : props.showTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD'
})
const change = () => {
  let startTime = ''
  let endTime = ''
  const format = props.valueFormat || 'YYYY/MM/DD'
  if (time.value && time.value.length) {
    startTime = time.value[0]
    endTime = time.value[1]
    if (props.autoTime && !props.showTime) {
      startTime = dayjs(startTime).format(format) + ' 00:00:00'
      endTime = dayjs(endTime).format(format) + ' 23:59:59'
    }
  }
  // 默认为电脑本地时间，如果需要转换为北京时间，需要传入isOutputBeijingTime
  startTime = startTime && props.isOutputBeijingTime ? toBeijingTime(startTime, `${format} HH:mm:ss`) : startTime
  endTime = endTime && props.isOutputBeijingTime ? toBeijingTime(endTime, `${format} HH:mm:ss`) : endTime
  resultTime.value = [startTime, endTime]
  emit('update:startTime', startTime)
  emit('update:endTime', endTime)
  emit('change')
}
</script>
